/* eslint-disable */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Carousel as StyledCarousel,
  Dot,
  DotsWrapper,
  ThumbnailsWrapper,
  Thumbnail,
  ThumbnailsContainer
} from './CarouselStyledComponents'
import NoImage from '../../../assets/images/no_image.png'

const CarouselContext = React.createContext()

const Carousel = ({ images = [], children }) => {
  const [activeSlide, setActiveSlide] = useState(0)

  const onChange = useCallback(value => {
    setActiveSlide(value)
  }, [])

  const slides = images.length
    ? images.map((img, index) => <img key={index} src={img} />)
    : [<img key="img" src={NoImage} />]

  return (
    <CarouselContext.Provider value={{ activeSlide, onChange, images }}>
      <StyledCarousel slides={slides} value={activeSlide} plugins={['fastSwipe']} onChange={onChange} />
      {children}
    </CarouselContext.Provider>
  )
}

Carousel.Dots = () => {
  const { images, onChange, activeSlide } = React.useContext(CarouselContext)
  return (
    <DotsWrapper>
      {images.map((_, index) => (
        <Dot type="button" key={index} active={index === activeSlide} onClick={() => onChange(index)} />
      ))}
    </DotsWrapper>
  )
}

Carousel.Thumbnails = () => {
  const { images, onChange, activeSlide } = React.useContext(CarouselContext)
  const wrapper = useRef()

  useEffect(() => {
    scrollIntoView(activeSlide)
  }, [activeSlide])

  const scrollIntoView = useCallback(
    (activeSlide, behavior = 'smooth') => {
      const parent = wrapper.current
      const element = wrapper.current.children[0].children[activeSlide]

      const height = element.offsetHeight
      const top = element.offsetTop
      const parentTop = parent.scrollTop
      const parentHeight = parent.offsetHeight

      parent.scrollTo({
        top: top,
        behavior: behavior
      })

      if (top + height - parentTop > parentHeight) {
        parent.scrollTo({
          top: top + height,
          behavior: behavior
        })
      } else {
        parent.scrollTo({
          top: top - height,
          behavior: behavior
        })
      }
    },

    [wrapper.current]
  )

  return (
    <ThumbnailsWrapper ref={wrapper}>
      <ThumbnailsContainer>
        {images.map((src, index) => (
          <Thumbnail
            src={src}
            key={index}
            active={index === activeSlide}
            onClick={e => {
              onChange(index)
              // onBeforeFocus(e);
            }}
          />
        ))}
      </ThumbnailsContainer>
    </ThumbnailsWrapper>
  )
}

Carousel.propTypes = {
  images: PropTypes.arrayOf('stirng')
}

export default Carousel
